import { useTranslation } from 'react-i18next';
import type { ILookupFooterProps } from './ILookupFooterProps';

/** Підвал списку пошуку (прототип lkCount): «N з M» ліворуч, праворуч — дії акцентом 11px 600 («Розширений пошук…»). */
export function LookupFooter({ count, total, onAdvanced, extra }: ILookupFooterProps) {
  const { t } = useTranslation();
  return (
    <>
      <span>{t('fieldControls.countOf', { count, total })}</span>
      <span className="pk-list__actions">
        {extra}
        {onAdvanced && (
          <button type="button" className="pk-list__link" onMouseDown={(e) => { e.preventDefault(); onAdvanced(); }}>{t('fieldControls.advancedSearch')}</button>
        )}
      </span>
    </>
  );
}
